import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareVersionDetailRoute: InvariantJiraRoute = {
	name: 'software-version-detail',
	path: '/projects/:projectKey/versions/:versionId/tab/:tab',
};
